export enum EKwikUIInputTimeSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputTimeSize = [
  EKwikUIInputTimeSize.S,
  EKwikUIInputTimeSize.M,
  EKwikUIInputTimeSize.L
] as const;

export type TKwikUIInputTimeSize = (typeof VKwikUIInputTimeSize)[number];

export enum EKwikUIInputTimeMode {
  HH_MM = "HH:MM",
  HH_MM_SS = "HH:MM:SS",
  HH_MM_SS_MSS = "HH:MM:SS.MSS"
}
export const VKwikUIInputTimeMode = [
  EKwikUIInputTimeMode.HH_MM,
  EKwikUIInputTimeMode.HH_MM_SS,
  EKwikUIInputTimeMode.HH_MM_SS_MSS
] as const;

export type TKwikUIInputTimeMode = (typeof VKwikUIInputTimeMode)[number];
